import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DivLayout from "components/sales/divLayout/divLayout";
import localization from "assets/localization/localization";
import GoogleMapReact from "google-map-react";
import "pages/attendance/attendanceDetails/attStyle.css";
import DocumentView from "components/sales/downloadDocView/documentView";
import CardSection from "components/sales/cardSection/cardSection";
import TableSection from "components/sales/tableSection/tableSection";

const MeetingData = ({
  details,
  poc = [],
  othersEmail = [],
  paymentData = [],
  contractPoc= []
}) => {
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi6",
    lat: Number(details.latitude),
    lng: Number(details.longitude),
  });
  const [isMap, setMap] = useState(1);
  const [listData, setListData] = useState([]);
  function renderMarkers(map, maps) {
    console.log(details);
    let markers = [
      // Just an example this should probably be in your state or props.
      {
        name: "marker1",
        position: {
          lat: Number(details.latitude),
          lng: Number(details.longitude),
        },
      },
      {
        name: "Site",
        position: {
          lat: Number(details.site_lat),
          lng: Number(details.site_lng),
        },
      },
    ];
    {
      markers.map(
        (marker1, index) =>
          new maps.Marker({
            key: index,
            position: marker1.position,
            name: marker1.name,
            map,
            title: marker1.name == "marker1" ? "You are here!" : "Site",
            icon: {
              url:
                marker1.name == "marker1"
                  ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                  : "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            },
          })
      );
    }
  }
  const headers = [
    '',
    'Name',
    'Designation',
    'Email',
    'Contact Number',
    'Level'
];


useEffect(() => {
  if (contractPoc && contractPoc !== undefined && contractPoc?.length > 0) {
    const tableData = [
      'id', 
      'name', 
      'designation', 
      'email', 
      'contact_no', 
      'level'
    ];

    const data = contractPoc?.map((element) => {
      return tableData.reduce((acc, key) => {
        acc[key] = element[key];
        return acc;
      }, {});
    });

    setListData(data);
  }
}, [contractPoc]);


  function googleMapRender() {
    return (
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ" }}
        defaultCenter={mapLocation}
        defaultZoom={15}
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
      ></GoogleMapReact>
    );
  }

  useEffect(() => {
    // Page Reload
    // location.reload('.google-map-meet');
  }, [details?.site_lat]);

  return (
    <>
      <div className="panel-card">
        <div className="panel-heading">{localization.meetingDetails}</div>
        <div className="panel-body">
          <div className="details-listing">
            {/* <div className="details-list">
            <strong className="data-title">{localization.raisedTo}</strong>
            <span className="data-details">
              {poc.length > 0
                ? poc.map((val, i) => (
                    <span key={i} className="comma-separated">
                      {val.name}
                    </span>
                  ))
                : localization.na}
            </span>
          </div> */}

            {/* <div className="details-list">
            <strong className="data-title">{localization.othersEmail}</strong>
            <span className="data-details">
              {othersEmail.length > 0
                ? othersEmail.map((val, i) => (
                    <span key={i} className="comma-separated">
                      {val}
                    </span>
                  ))
                : localization.na}
            </span>
          </div> */}

            <DivLayout
              heading={localization.client}
              data={details?.client_name ? `${details.client_name}` : "Others"}
            />
            {details?.site_id == 0 && details?.other_client_name && (
              <DivLayout
                heading={localization.siteName}
                data={
                  details?.other_client_name
                    ? `${details.other_client_name}`
                    : "N/A"
                }
              />
            )}
            {details?.site_id == 0 && details?.other_site && (
              <DivLayout
                heading={localization.site}
                data={details?.other_site ? `${details.other_site}` : "N/A"}
              />
            )}
            {details?.site_id == 0 && details?.other_client_email && (
              <DivLayout
                heading={localization.clientEmail}
                data={
                  details?.other_client_email
                    ? `${details.other_client_email}`
                    : "N/A"
                }
              />
            )}
            <DivLayout
              heading={localization.siteNumber}
              data={details?.site_no ? `${details.site_no}` : localization.na}
            />
            <DivLayout
              heading={localization.scheduledDate}
              data={
                details?.scheduled_date
                  ? details.scheduled_date
                  : localization.na
              }
            />
            <DivLayout
              heading={localization.scheduledTime}
              data={
                details?.scheduled_time
                  ? details.scheduled_time
                  : localization.na
              }
            />
            <DivLayout
              heading={localization.distabceBetweenSiteAndUser}
              data={
                details?.distance ? `${details.distance} KM` : localization.na
              }
            />
            {/* <DivLayout
            heading={localization.status}
            data={details?.status ? details.status : localization.na}
            status
          /> */}
            <DivLayout
              heading={localization.createdOn}
              data={details?.created_on ? details.created_on : localization.na}
            />
            <DivLayout
              heading={localization.meetingAgenda}
              data={details?.subject ? details.subject : localization.na}
            />
            {details?.subject &&
            String(details.subject).trim().toLowerCase() === 'sales' &&
            (details?.sub_subject ||
              details?.draft_data?.sub_subject ||
              details?.checkout_details?.sub_subject) ? (
              <DivLayout
                heading={localization.subMeetingAgenda}
                data={
                  details?.sub_subject ||
                  details?.draft_data?.sub_subject ||
                  details?.checkout_details?.sub_subject ||
                  localization.na
                }
              />
            ) : null}
            {details && details.remark ? (
              <DivLayout
                heading={localization.subject}
                data={details?.remark ? details.remark : localization.na}
              />
            ) : null}

            {details &&
            details?.cheque_picked &&
            details?.cheque_picked === "Yes" ? (
              <>
                {paymentData &&
                  paymentData?.length > 0 &&
                  paymentData.map((val, index) => {
                    return (
                      <>
                        <CardSection title={"Payment Detail " + (index + 1)}>
                          <div className="details-listing">
                            <DivLayout
                              heading={localization.invoice}
                              data={
                                val.invoice_no
                                  ? val.invoice_no
                                  : localization.na
                              }
                            />
                            <DivLayout
                              heading={localization.bankName}
                              data={
                                val.bank_name ? val.bank_name : localization.na
                              }
                            />
                            <DivLayout
                              heading={localization.chequeTrnxNo}
                              data={
                                val.cheque_trnx_no
                                  ? val.cheque_trnx_no
                                  : localization.na
                              }
                            />
                            <DivLayout
                              heading={localization.chequeTrnxAmt}
                              data={
                                val.cheque_trnx_amount
                                  ? val.cheque_trnx_amount
                                  : localization.na
                              }
                            />
                            <DivLayout
                              heading={localization.trnxDate}
                              data={
                                val.cheque_trnx_date
                                  ? val.cheque_trnx_date
                                  : localization.na
                              }
                            />
                            <DivLayout
                              heading={localization.status}
                              data={val.status ? val.status : localization.na}
                            />
                            <DocumentView
                              attachment={val.doc_file}
                              title={"Document"}
                            />
                          </div>
                        </CardSection>
                      </>
                    );
                  })}
              </>
            ) : null}
            {details &&
            details?.cheque_picked &&
            details?.cheque_picked === "No" ? (
              <>
                <DivLayout
                  heading={localization.chequePicked}
                  data={
                    details?.cheque_picked
                      ? details.cheque_picked
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.chequeReason}
                  data={
                    details?.cheque_remark
                      ? details.cheque_remark
                      : localization.na
                  }
                />
              </>
            ) : null}
          </div>

          {details?.checkout_details !== null && (
            <>
              <div className="panel-card">
                <div className="panel-heading">
                  {localization.checkoutDetails}
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={"POC Name:"}
                      data={
                        details?.checkout_details?.poc_name
                          ? `${details?.checkout_details?.poc_name}`
                          : null
                      }
                    />
                    <DivLayout
                      heading={"Contact No.:"}
                      data={
                        details?.checkout_details?.mobile_number
                          ? `${details?.checkout_details?.mobile_number}`
                          : null
                      }
                    />
                    <DivLayout
                      heading={"Email ID:"}
                      data={
                        details?.checkout_details?.email_id
                          ? `${details?.checkout_details?.email_id}`
                          : null
                      }
                    />
                    <DivLayout
                      heading={"POC Remark:"}
                      data={
                        details?.checkout_details?.poc_remark
                          ? `${details?.checkout_details?.poc_remark}`
                          : null
                      }
                    />
                    <DivLayout
                      heading={"Feedback/Rating taken from the client:"}
                      data={
                        details?.checkout_details?.feedback_dropdown
                          ? `${details?.checkout_details?.feedback_dropdown}`
                          : null
                      }
                    />
                    {details.checkout_details.feedback_dropdown === "No" && (
                      <DivLayout
                        heading={"Feedback/Rating Reason:"}
                        data={
                          details?.checkout_details?.client_reason
                            ? `${details?.checkout_details?.client_reason}`
                            : localization.na
                        }
                      />
                    )}
                    <DivLayout
                      heading={"Dashboard training given to the POC :"}
                      data={
                        details?.checkout_details?.dashboard_check
                          ? `${details?.checkout_details?.dashboard_check}`
                          : null
                      }
                    />
                    {details.checkout_details.dashboard_check === "No" && (
                      <DivLayout
                        heading={"Dashboard training Reason:"}
                        data={
                          details?.checkout_details?.dashboard_reason
                            ? `${details?.checkout_details?.dashboard_reason}`
                            : localization.na
                        }
                      />
                    )}
                    <DivLayout
                      heading={
                        "Client knows how to raise ticket from dashboard :"
                      }
                      data={
                        details?.checkout_details?.training_check
                          ? `${details?.checkout_details?.training_check}`
                          : null
                      }
                    />
                    {details.checkout_details.training_check === "No" && (
                      <DivLayout
                        heading={"Client Reason:"}
                        data={
                          details?.checkout_details?.training_reason
                            ? `${details?.checkout_details?.training_reason}`
                            : localization.na
                        }
                      />
                    )}
                    <DivLayout
                      heading={"Discussion on any existing open complaint:"}
                      data={
                        details?.checkout_details?.complaint_check
                          ? `${details?.checkout_details?.complaint_check}`
                          : null
                      }
                    />
                    {details.checkout_details.complaint_check === "No" && (
                      <DivLayout
                        heading={"Discussion Reason:"}
                        data={
                          details?.checkout_details?.complaint_reason
                            ? `${details?.checkout_details?.complaint_reason}`
                            : localization.na
                        }
                      />
                    )}
                    <DivLayout
                      heading={"Whatsapp group deletion:"}
                      data={
                        details?.checkout_details?.whatsapp_check
                          ? `${details?.checkout_details?.whatsapp_check}`
                          : null
                      }
                    />
                    {details.checkout_details.whatsapp_check === "No" && (
                      <DivLayout
                        heading={"Whatsapp Reason:"}
                        data={
                          details?.checkout_details?.whatsapp_reason
                            ? `${details?.checkout_details?.whatsapp_reason}`
                            : localization.na
                        }
                      />
                    )}
                    <DivLayout
                      heading={"Vms Check:"}
                      data={
                        details?.checkout_details?.vms_check
                          ? `${details?.checkout_details?.vms_check}`
                          : null
                      }
                    />
                    {details.checkout_details.vms_check === "Yes" && (
                      <>
                        <DivLayout
                          heading={"Vms Type:"}
                          data={
                            details?.checkout_details?.vms_type
                              ? `${details?.checkout_details?.vms_type}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.vms_type === "Others" && (
                          <DivLayout
                            heading={"Vms Type Reason:"}
                            data={
                              details?.checkout_details?.vms_others_reason
                                ? `${details?.checkout_details?.vms_others_reason}`
                                : localization.na
                            }
                          />
                        )}
                        <DivLayout
                          heading={"Since when you are using vms:"}
                          data={
                            details?.checkout_details?.vms_duration
                              ? `${details?.checkout_details?.vms_duration}`
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={"Type of usage:"}
                          data={
                            details?.checkout_details?.vms_usage
                              ? `${details?.checkout_details?.vms_usage}`
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={"Is your vms a paid service:"}
                          data={
                            details?.checkout_details?.vms_paid
                              ? `${details?.checkout_details?.vms_paid}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.vms_paid === "Yes" && (
                          <DivLayout
                            heading={"Vms Payment Duration:"}
                            data={
                              details?.checkout_details?.vms_paid_type
                                ? `${details?.checkout_details?.vms_paid_type}`
                                : localization.na
                            }
                          />
                        )}
                        <DivLayout
                          heading={
                            "Using application for paying maintenance dues:"
                          }
                          data={
                            details?.checkout_details?.vms_maintenance_check
                              ? `${details?.checkout_details?.vms_maintenance_check}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.vms_maintenance_check ===
                          "Yes" && (
                          <>
                            <DivLayout
                              heading={"Vms Payment Type:"}
                              data={
                                details?.checkout_details?.vms_paid_type
                                  ? `${details?.checkout_details?.vms_paid_type}`
                                  : localization.na
                              }
                            />
                            {details.checkout_details.vms_paid_type ===
                              "Others" && (
                              <DivLayout
                                heading={"Vms Payment Type Reason:"}
                                data={
                                  details?.checkout_details
                                    ?.vms_maintenance_remark
                                    ? `${details?.checkout_details?.vms_maintenance_remark}`
                                    : localization.na
                                }
                              />
                            )}
                          </>
                        )}
                      </>
                    )}
                    <DivLayout
                      heading={"Pre-Alignment for brand promotion:"}
                      data={
                        details?.checkout_details?.alignment_check
                          ? `${details?.checkout_details?.alignment_check}`
                          : null
                      }
                    />
                    {details.checkout_details.alignment_check === "No" && (
                      <DivLayout
                        heading={"Pre-Alignment Reason:"}
                        data={
                          details?.checkout_details?.alignment_reason
                            ? `${details?.checkout_details?.alignment_reason}`
                            : localization.na
                        }
                      />
                    )}
                    {details.checkout_details.alignment_check === "Yes" && (
                      <>
                        <DivLayout
                          heading={"Car Display:"}
                          data={
                            details?.checkout_details?.car_check
                              ? `${details?.checkout_details?.car_check}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.car_check === "No" && (
                          <DivLayout
                            heading={"Car Display Reason:"}
                            data={
                              details?.checkout_details?.car_reason
                                ? `${details?.checkout_details?.car_reason}`
                                : localization.na
                            }
                          />
                        )}
                        <DivLayout
                          heading={"Sampling approval and commercials:"}
                          data={
                            details?.checkout_details?.sampling_check
                              ? `${details?.checkout_details?.sampling_check}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.sampling_check === "No" && (
                          <DivLayout
                            heading={"Car Display Reason:"}
                            data={
                              details?.checkout_details?.sampling_reason
                                ? `${details?.checkout_details?.sampling_reason}`
                                : localization.na
                            }
                          />
                        )}
                        <DivLayout
                          heading={"Kiosking approval and commercials:"}
                          data={
                            details?.checkout_details?.kiosking_check
                              ? `${details?.checkout_details?.kiosking_check}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.kiosking_check === "No" && (
                          <DivLayout
                            heading={"Kiosking Reason:"}
                            data={
                              details?.checkout_details?.kiosking_reason
                                ? `${details?.checkout_details?.kiosking_reason}`
                                : localization.na
                            }
                          />
                        )}
                        <DivLayout
                          heading={
                            "Door to door campaign approval and commercials:"
                          }
                          data={
                            details?.checkout_details?.door_check
                              ? `${details?.checkout_details?.door_check}`
                              : localization.na
                          }
                        />
                        {details.checkout_details.door_check === "No" && (
                          <DivLayout
                            heading={"Door Reason:"}
                            data={
                              details?.checkout_details?.door_reason
                                ? `${details?.checkout_details?.door_reason}`
                                : localization.na
                            }
                          />
                        )}
                      </>
                    )}
                    <DivLayout
                      heading={"Waiting time:"}
                      data={
                        details?.checkout_details?.waiting_time
                          ? `${details?.checkout_details?.waiting_time}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Flat Count:"}
                      data={
                        details?.checkout_details?.flat_count
                          ? `${details?.checkout_details?.flat_count}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Flat Cost:"}
                      data={
                        details?.checkout_details?.flat_cost
                          ? `${details?.checkout_details?.flat_cost}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Monthly Main Fees:"}
                      data={
                        details?.checkout_details?.monthly_main_fees
                          ? `${details?.checkout_details?.monthly_main_fees}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Facility Management:"}
                      data={
                        details?.checkout_details?.facility_management
                          ? `${details?.checkout_details?.facility_management}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Locality:"}
                      data={
                        details?.checkout_details?.locality
                          ? `${details?.checkout_details?.locality}`
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={"Is Upselling Opportunity Exist?"}
                      data={
                        details?.checkout_details
                          ?.is_upselling_opportunity_exist
                          ? `${details?.checkout_details?.is_upselling_opportunity_exist}`
                          : localization.na
                      }
                    />
                    {/*<DivLayout*/}
                    {/*    heading={"Upselling Opportunity Reason"}*/}
                    {/*    data={*/}
                    {/*        details?.checkout_details?.is_upselling_opportunity_exist_reason*/}
                    {/*            ? `${details?.checkout_details?.is_upselling_opportunity_exist_reason}`*/}
                    {/*            : localization.na*/}
                    {/*    }*/}
                    {/*/>*/}

                    <DivLayout
                      heading={"Upselling Opportunity Exist"}
                      data={
                        details?.checkout_details
                          ?.existing_upselling_opportunity
                          ? `${details?.checkout_details?.existing_upselling_opportunity.toString()}`
                          : localization.na
                      }
                    />

                    <DivLayout
                      heading={"Upselling Opportunity other"}
                      data={
                        details?.checkout_details
                          ?.existing_upselling_opportunity_other
                          ? `${details?.checkout_details?.existing_upselling_opportunity_other}`
                          : localization.na
                      }
                    />
                    {details?.checkout_details?.referral_discussed &&
                      details?.checkout_details?.referral_discussed != "" && (
                        <DivLayout
                          heading={"Referral discussed during the meeting"}
                          data={
                            details?.checkout_details?.referral_discussed
                              ? `${details?.checkout_details?.referral_discussed}`
                              : localization.na
                          }
                        />
                      )}
                    {details?.checkout_details?.referral_discussed &&
                      details?.checkout_details?.referral_discussed ===
                        "Yes" && (
                        <DivLayout
                          heading={"Did client refer lead"}
                          data={
                            details?.checkout_details?.did_client_refer_lead
                              ? `${details?.checkout_details?.did_client_refer_lead}`
                              : localization.na
                          }
                        />
                      )}
                    {details?.checkout_details?.did_client_refer_lead &&
                      details?.checkout_details?.did_client_refer_lead ===
                        "Yes" && (
                        <DivLayout
                          heading={"Type of referral"}
                          data={
                            details?.checkout_details?.type_of_referral
                              ? `${details?.checkout_details?.type_of_referral}`
                              : localization.na
                          }
                        />
                      )}
                    {details?.checkout_details?.client_reffer_no &&
                      details?.checkout_details?.client_reffer_no != "" && (
                        <DivLayout
                          heading={"Client referral reason (if No)"}
                          data={
                            details?.checkout_details?.client_reffer_no
                              ? `${details?.checkout_details?.client_reffer_no}`
                              : localization.na
                          }
                        />
                      )}
                    {details?.checkout_details?.referral_no_reason &&
                      details?.checkout_details?.referral_no_reason != "" && (
                        <DivLayout
                          heading={"Referral reason (if No)"}
                          data={
                            details?.checkout_details?.referral_no_reason
                              ? `${details?.checkout_details?.referral_no_reason}`
                              : localization.na
                          }
                        />
                      )}
                    
                      {details?.checkout_details?.for_hot_nego_sites && (
                        <>
                        <DivLayout
                          heading={localization?.callToHotNegotiationSites}
                          data={
                            details?.checkout_details?.for_hot_nego_sites == "Yes"
                              ? "Yes"
                              : "No"
                          }
                        />
                        {details?.checkout_details?.for_hot_nego_sites == "No" && details?.checkout_details?.not_hot_nego_sites_reason && (
                          <DivLayout
                            heading={"Reason for No"}
                            data={details?.checkout_details?.not_hot_nego_sites_reason || localization.na}
                          />
                        )}
                        </>
                      )}

                      {details?.checkout_details?.shared_referral_message && (
                        <>
                        <DivLayout
                          heading={localization?.referralSharedViaWA}
                          data={
                            details?.checkout_details?.shared_referral_message == "Yes"
                              ? "Yes"
                              : "No"
                          }
                        />
                        {details?.checkout_details?.shared_referral_message == "No" &&
                          details?.checkout_details?.not_shared_referral_reason && (
                            <DivLayout
                              heading={"Reason for No"}
                              data={details?.checkout_details?.not_shared_referral_reason || localization?.na}
                            />
                          )}
                        </>
                      )}

                      {details?.checkout_details?.got_video_testimonial && (
                        <>
                        <DivLayout
                          heading={localization?.videoTestimonialFromClient}
                          data={
                            details?.checkout_details?.got_video_testimonial === "Yes"
                              ? "Yes"
                              : "No"
                          }
                        />
                        {details?.checkout_details?.got_video_testimonial === "No" &&
                          details?.checkout_details?.no_video_testimonial_reason && (
                            <DivLayout
                              heading={"Reason for No"}
                              data={details?.checkout_details?.no_video_testimonial_reason || localization.na}
                            />
                          )}
                        </>
                      )}
                    {details?.checkout_details?.whatsapp_upload &&
                      details?.checkout_details?.whatsapp_upload != "" && (
                        <DocumentView
                          attachment={
                            details?.checkout_details?.whatsapp_upload
                          }
                          title={"File"}
                        />
                      )}

                      {details?.checkout_details?.risk_category && 
                      details?.checkout_details?.risk_category != "" &&  (
                        <DivLayout
                          heading={"Risk Category"}
                          data={details?.checkout_details?.risk_category || localization.na}
                        />
                      )}

                      {details?.checkout_details?.churn_risk && 
                      details?.checkout_details?.churn_risk != "" &&  (
                        <DivLayout
                          heading={"Churn Risk"}
                          data={details?.checkout_details?.churn_risk || localization.na}
                        />
                      )}

                    {details?.checkout_details?.risk_category && 
                      details?.checkout_details?.risk_category === "Other" &&  (
                        <DivLayout
                          heading={"Risk Category Other Reason"}
                          data={details?.checkout_details?.risk_category_other || localization.na}
                        />
                      )}

                      
                    <DocumentView
                      attachment={details?.checkout_details?.selfieUrl}
                      title={"Selfie"}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="details-list full-width">
            {details &&
              details.attachment &&
              details.attachment.map((attachments) => (
                <DocumentView attachment={attachments} />
              ))}
          </div>
          <div className="row">
            <div className="col-md-6">
              <img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png" />{" "}
              : <strong>Site</strong>
            </div>
            <div className="col-m-6">
              <img src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png" />{" "}
              : <strong>You</strong>
            </div>
          </div>

          <div className="map">
            {/* {console.log(details)} */}

            <div className="google-map-meet">
              {/* {(details?.site_lat ?
              <>  
                  {googleMapRender()}
                </>
               : null   
              )}
               */}
            </div>
          </div>
          {details?.opportunity !== undefined &&
            details?.opportunity !== null && (
              <>
                <div className="panel-card">
                  <div className="panel-heading">
                    {localization.opportunity}
                  </div>
                  <div className="panel-body">
                    <div className="details-listing">
                      {/* eslint-disable-next-line array-callback-return */}
                      {details?.opportunity.map((value, i) => {
                        return (
                          <DivLayout
                            heading={localization.opportunity + (i + 1)}
                            data={value}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
      { (contractPoc && contractPoc !== undefined && contractPoc?.length > 0) && (
        <div className="panel-card">
          <div className="panel-heading">{'Contract POC Details'}</div>
          <div className="panel-body">
            <div className="details-listing">
            <TableSection
              data={listData}
              isId={true}
              headers={headers}
            />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

MeetingData.propTypes = {
  details: PropTypes.any,
};

export default MeetingData;
